import React, { useState, useEffect } from 'react';
import Modal from './components/Modal';
import InspectionModal from './components/InspectionModal';

// Make API calls use WordPress URLs
if (typeof window !== 'undefined' && window.wpData) {
  window.apiBaseUrl = window.wpData.apiUrl.replace('http://', 'https://'); // Force HTTPS
}

const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('inspection');

  const openModal = (type = 'inspection') => {
    setModalType(type);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    // Listen for modal open event from WordPress
    window.openInspectionModal = () => openModal('inspection');

    // Also listen for custom event
    const handleOpenModal = (event) => {
      if (
        event.target?.closest('.no-modal') ||
        event.target?.dataset?.noModal
      ) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const type = event.detail?.type || 'inspection';
      openModal(type);
    };
    window.addEventListener('openInspectionModal', handleOpenModal);

    return () => {
      window.removeEventListener('openInspectionModal', handleOpenModal);
    };
  }, []);

  const renderModalContent = () => {
    switch (modalType) {
      case 'inspection':
        return <InspectionModal onClose={closeModal} />;
      default:
        return <InspectionModal onClose={closeModal} />;
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {renderModalContent()}
      </Modal>
    </div>
  );
};

export default App;
